// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__DbQmn","selector":"Register_selector__pSw45","form":"Register_form__c8aUa","but":"Register_but__D3ZNW"};